import { Gender as GenderType } from "../../shared/sdk/types"

type Gender = {
    id: GenderType
    name: string
    visibleInAddress: boolean
}

const genders: Gender[] = [
    {
        id: "female",
        name: "configuration_gender_female",
        visibleInAddress: true,
    },
    {
        id: "male",
        name: "configuration_gender_male",
        visibleInAddress: true,
    },
    {
        id: "other",
        name: "configuration_gender_other",
        visibleInAddress: false,
    },
]

export { genders }
